module.exports = __webpack_public_path__ + "static/media/law.88c1382f.jpg";